import { useTranslation } from "react-i18next";
import { TbShoppingBagSearch } from "react-icons/tb";

import classes from "./styles.module.css";
import Product from "src/pages/products/product/Product";
import ProductSkeleton from "src/pages/products/product/Skeleton";
import { useRandomProductsQuery } from "src/store/api/products/productsApiSlice";
import EmptyElement from "src/components/emptyElement/EmptyElement";

const SKELETON_COUNT = 8;

const RandomProducts = () => {
    const { t } = useTranslation(["home"]);
    const {
        data,
        isLoading,
        isFetching,
        isError,
        refetch,
    } = useRandomProductsQuery(undefined, {
        refetchOnReconnect: true,
        refetchOnMountOrArgChange: true,
    });

    const products = data || [];
    const hasProducts = products.length > 0;

    return (
        <section className={classes.randomProducts} aria-labelledby="home-random-products-title">
            <div className="container">
                <div className={classes.sectionShell}>
                    <div className={classes.header}>
                        <div>
                            <h2 id="home-random-products-title" className={classes.title}>
                                {t("randomProducts.title")}
                            </h2>
                            <p className={classes.subtitle}>
                                {t("randomProducts.subtitle")}
                            </p>
                        </div>

                        {isFetching && hasProducts && (
                            <span className={classes.refreshing} role="status">
                                {t("randomProducts.refreshing")}
                            </span>
                        )}
                    </div>

                    {isLoading && !hasProducts && (
                        <div className={classes.grid} aria-label={t("randomProducts.loading")}>
                            {Array.from({ length: SKELETON_COUNT }, (_, index) => (
                                <ProductSkeleton key={`random-products-skeleton-${index}`} />
                            ))}
                        </div>
                    )}

                    {isError && !hasProducts && (
                        <div className={classes.state} role="status">
                            <p>{t("randomProducts.error")}</p>
                            <button type="button" className={`btn__primary ${classes.retry}`} onClick={() => refetch()}>
                                {t("randomProducts.retry")}
                            </button>
                        </div>
                    )}

                    {!isLoading && !isError && !hasProducts && (
                        <EmptyElement
                            variant="inline"
                            icon={<TbShoppingBagSearch />}
                            title={t("randomProducts.empty_title")}
                            msg={t("randomProducts.empty")}
                        />
                    )}

                    {hasProducts && (
                        <div className={classes.grid}>
                            {products.slice(0, 12).map((product) => (
                                <Product key={`random-product-${product.id}`} product={product} variant="home" />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default RandomProducts;
